import { isSameMonth, isSameYear } from 'date-fns';

import { formatDate } from 'utils/date/formatDate';

export enum INTERVAL_FORMAT {
    SHORT = 'short',
    MEDIUM = 'medium',
    LONG = 'long',
}

export function formatInterval(start: Date, end: Date, format: INTERVAL_FORMAT) {
    let dateFormat = '';
    let fullDateFormat = '';

    switch (format) {
        case INTERVAL_FORMAT.LONG:
            dateFormat = 'd MMMM';
            fullDateFormat = 'd MMMM, yyyy';
            break;
        case INTERVAL_FORMAT.MEDIUM:
            dateFormat = 'd MMM';
            fullDateFormat = 'd MMM yyyy';
            break;
        case INTERVAL_FORMAT.SHORT:
            dateFormat = fullDateFormat = 'd.MM';
            break;
    }

    return formatIntervalUtil(start, end, dateFormat, fullDateFormat);
}

function formatIntervalUtil(start: Date, end: Date, dateFormat: string, fullDateFormat: string) {
    if (isSameYear(start, end)) {
        const right = formatDate(end, isSameYear(start, Date.now()) ? dateFormat : fullDateFormat);
        return isSameMonth(start, end)
            ? `${formatDate(start, 'd')}–${right}`
            : `${formatDate(start, dateFormat)} – ${right}`;
    }

    return `${formatDate(start, fullDateFormat)} – ${formatDate(end, fullDateFormat)}`;
}
